module.exports = __webpack_public_path__ + "img/de21544.png";